module.exports = __webpack_public_path__ + "static/media/icon_subtraction_conditional.6c3fa3a7.svg";